<template>
  <div v-if="surveillance">
    <h2>Étude de recherche
      <span class="label" ref="title" :class="`label-${module}`">
        {{ moduleName }}
      </span>
    </h2>
    <hr>
    <div class="row">
      <div class="col-lg-10 col-xs-12">
        <div class="row">
          <div class="col-lg-12 col-xs-12">
            <alert type="warning">
              <h4>
                Bienvenue sur l'espace
                <span class="label" :class="`label-${module}`">{{ moduleName }}</span>
                pour le programme SPIADI{{year}}
                <small>
                </small>
              </h4>
              <p>
                Afin de valider votre participation à l'étude, il vous faut saisir vos données en
                utilisant les trois formulaires sphinx accessibles ci-dessous :
                <ul>
                  <li>Un formulaire pour <b>la Fiche «Service»</b></li>
                  <li>Un formulaire pour <b><u>les 5 Fiches</u> «Maintien du CVP»</b></li>
                  <li>Un formulaire pour <b><u>une seule</u> Fiche «Patient Bactériémique», à remplir autant de fois que vous avez de fiches papiers</b></li>
                </ul>
              </p>
              <p>
                Les questionnaires doivent être complétés avant le <strong>15 juillet 2025</strong> afin de permettre une analyse statistique poussée.
                Les résultats de l’étude seront restitués lors de la septième journée nationale de la SPIADI le 2 octobre 2025.
              </p>
            </alert>

            <div class="panel panel-topCvp">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-sm-2 col-xs-12">
                    <h2 class="panel-title">
                      <img class="img-responsive logo"
                           :src="require('@/assets/img/logo-topcvp.png')"/>
                    </h2>
                  </div>
                  <div class="col-xs-12 col-sm-10">
                    <h2 class="hidden-xs">
                      Étude de l'impact des mesures de prévention
                      des bactériémies liées à un CVP
                    </h2>
                    <h4 class="visible-xs text-center">
                      Étude de l'impact des mesures de prévention
                      des bactériémies liées à un CVP
                    </h4>
                  </div>
                </div>
              </div>
              <div class="panel-body">
                <alert type="warning" class="text-left">
                  <h4>
                    <span class="glyphicon glyphicon-flash" aria-hidden="true">
                    </span>Attention :
                    lorsque vous commencez un formulaire, il vous faut le remplir jusqu'au bout
                    <span class="glyphicon glyphicon-flash" aria-hidden="true">
                    </span>
                  </h4>
                  <p>
                    Il n'est pas possible s'arrêter en cours de route et de sauvegarder la saisie
                    afin d'y revenir plus tard.
                  </p>
                  <p>
                    <strong>
                      Veillez donc à réunir toutes les informations de la fiche avant de commencer à saisir.
                    </strong>
                  </p>
                </alert>
                <div class="row">
                  <div class="col-sm-4 col-xs-12"
                       v-for="form in sc.top.forms"
                       :key="`form-${form.id}`">
                    <a :href="form.url"
                     class="btn btn-lg btn-block action-btn"
                     :class="`btn-${form.style}`"
                     target="_blank">
                      <span class="icon-container">
                        <svg-icon :icon="form.icon" color="white"/>
                      </span>
                      {{ form.title }}
                    </a>
                    <div class="text-justify form-text">
                      <p v-html="form.text">
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div :class="`panel panel-default`">
              <div class="panel-heading">
                <div class="panel-title">
                  <h3>Téléchargements</h3>
                </div>
              </div>
              <div class="panel-body">
                <ul>
                  <div v-for="(b, k) in sc.top.files"
                       :key="k">
                    <link-block :file="b.file"
                                :link="b.link"
                                :description="b.description"
                                :title="b.title"
                                class="fb-topCvp col-xs-6 col-md-4"
                                :text="b.text"
                                :icon="b.icon">
                    </link-block>
                    <div v-if="!((k + 1) % 3)" class="hidden-xs clearfix"></div>
                    <div v-if="!((k + 1) % 2)" class="visible-xs clearfix"></div>
                  </div>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

import modules from '@/sui/data/modules'
import sc from '@/views/sc/research'
import linkBlock from '@/components/linkBlock.vue'
import svgIcon from '@/sui/components/svgIcon'

export default {
  name: 'top-cvp-dashboard',

  props: {
    surveillance: {
      type: Object
    },

    year: {
      type: String,
      required: true
    },

    module: {
      type: String,
      required: true
    }
  },

  data: function () {
    return {
      sc: sc
    }
  },

  computed: {
    moduleName: function () {
      return modules[this.year][this.module].label
    }
  },

  components: {
    'link-block': linkBlock,
    'svg-icon': svgIcon
  }
}
</script>
<style scoped lang="less">
@import '~variables';
.logo {
  max-height: 10rem;
  margin: auto;
}

.panel {
  h3 {
    margin-top: 0rem;
    margin-bottom: 0rem;
    text-align: center;
  }

  .action-btn {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    font-size: 120%;

    .icon-container {
      .svg-icon {
        width: 15%
      }
    }
  }

  .form-text {
    padding: 1.5rem;
    max-width: 30rem;
    margin: auto;
  }

  .action-btn:last-child {
    margin-bottom: 0rem;
  }

  .btn-block {
    max-width: 30rem;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
